/* eslint-disable no-void */
import * as vp from 'vopay';
import { useEffect, useState } from 'react';
import axios from 'axios';

import { useDataFetchIndicator } from '..';

import vopayApi from '../../services/api.config';

type HookProps = { api: vp.Api };
type HookTuple = [
  response: vp.AccountTransferToResponse,
  AccountTransferTo: (params: vp.AccountTransferToRequest) => void,
  reset: () => void,
  AccountTransferToPromise: (params: vp.AccountTransferToRequest) => Promise<vp.AccountTransferToResponse>,
];
type ApiHook = (props: HookProps) => HookTuple;

const usePostAccountTransferTo: ApiHook = ({ api }) => {
  const [, setDataFetchingInfo] = useDataFetchIndicator();
  const [shouldAccountTransferTo, setShouldAccountTransferTo] = useState(false);
  const source = axios.CancelToken.source();
  const [params, setParams] = useState<vp.AccountTransferToRequest>({
    Amount: 0,
    RecipientAccountID: '',
    DebitorClientAccountID: '',
    RecipientClientAccountID: '',
    Currency: '',
    ClientReferenceNumber: '',
    Notes: '',
    ParentTransactionID: '',
    IdempotencyKey: '',
  });
  const [response, setResponse] = useState<vp.AccountTransferToResponse>({
    Success: false,
    ErrorMessage: '',
    TransactionID: '',
  });

  useEffect(() => {
    if (!shouldAccountTransferTo) return () => {};

    const PostAccountTransferTo = async () => {
      setDataFetchingInfo(true, 'processing', 'fullScreen');
      const res = await api.postAccountTransferTo(params, source);
      setResponse(res);
      setDataFetchingInfo(false);
    };

    if (shouldAccountTransferTo) void PostAccountTransferTo();
    setShouldAccountTransferTo(false);
    return () => {
      source.cancel();
    };
  }, [shouldAccountTransferTo]);

  return [
    response,
    (_params: vp.AccountTransferToRequest) => {
      setParams(_params);
      setShouldAccountTransferTo(true);
    },
    () => {
      setResponse({
        Success: false,
        ErrorMessage: '',
        TransactionID: '',
      });
      setShouldAccountTransferTo(false);
    },
    async (_params: vp.AccountTransferToRequest) => {
      const res = await api.postAccountTransferTo(_params, source);
      return res;
    },
  ];
};

export default vopayApi.withApiHook<HookProps, HookTuple>(usePostAccountTransferTo);
